import React from "react";
import { useTranslation } from "react-i18next";

const CustomerDetails = ({ isOpen, onClose, customer }) => {

  const {t} = useTranslation();

  if (!isOpen) {
    return <></>;
  }

    const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div
      style={{
        maxWidth: "320px",
        border: "1px solid #ddd",
        borderRadius: "12px",
        padding: "20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      {/* Header */}
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}
      >
        <img
          src="https://i.pravatar.cc/60"
          alt="John Doe"
          style={{
            borderRadius: "50%",
            width: 60,
            height: 60,
            marginRight: 15,
          }}
        />
        <div>
          <h2 style={{ margin: 0, fontSize: 18, color: "#1F3A72" }}>
            {customer?.first_name} {customer.last_name}
          </h2>
          <div
            style={{
              fontSize: 14,
              color: "#627d98",
              display: "flex",
              alignItems: "center",
            }}
          >
           {customer?.email}
       
          </div>
        </div>
      </div>

      {/* Customer Info */}
      <div style={{ marginBottom: 20 }}>
        <h4
          style={{ color: "#9ba3b1", fontWeight: "normal", marginBottom: 10 }}
        >
          {t("customer_info")}
        </h4>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #ddd",
            borderRadius: "8px",
            padding: "6px 10px",
            marginBottom: 10,
            backgroundColor: "#f7f9fb",
          }}
        >
          <span role="img" aria-label="Phone" style={{ marginRight: 8 }}>
            📞
          </span>
          <span style={{ color: "#344054" }}>{customer?.phone}</span>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #ddd",
            borderRadius: "8px",
            padding: "6px 10px",
            backgroundColor: "#f7f9fb",
          }}
        >
          <span role="img" aria-label="Location" style={{ marginRight: 8 }}>
            📍
          </span>
          <span style={{ color: "#344054" }}>{customer?.address}</span>
        </div>
      </div>



      {/* Activity */}
      <div style={{ marginBottom: 20 }}>
        <h4
          style={{ color: "#9ba3b1", fontWeight: "normal", marginBottom: 10 }}
        >
          Activity
        </h4>
        <p style={{ fontSize: 14, color: "#344054", margin: "4px 0" }}>
          <strong>تم الإنشاء:</strong> {formatDate(customer?.created_at)}
        </p>
 
      </div>

      {/* Order Overview
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontWeight: "bold",
              fontSize: 18,
              margin: 0,
              color: "#344054",
            }}
          >
            {customer?.total_orders}
          </p>
          <p style={{ fontSize: 12, color: "#556987", margin: 0 }}>
            {t("totalOrders")}
          </p>
        </div>
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontWeight: "bold",
              fontSize: 18,
              margin: 0,
              color: "green",
            }}
          >
            {customer?.completed_orders}
          </p>
          <p style={{ fontSize: 12, color: "#556987", margin: 0 }}>{t("CompletedOrders")}</p>
        </div>
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontWeight: "bold",
              fontSize: 18,
              margin: 0,
              color: "red",
            }}
          >
            {customer?.cancelled_orders}
          </p>
          <p style={{ fontSize: 12, color: "#556987", margin: 0 }}>  {t("cancelledOrders")}</p>
        </div>
      </div>*/}
    </div>
  );
};

export default CustomerDetails;
